import {inject} from '@angular/core';
import {CanMatchFn, Router, UrlTree} from '@angular/router';
import {BrowserStorageService, CompanyAttributesBase, CompanyService} from '@core/services';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {toBoolean} from '@shared/components/common';

export const DASHBOARD_STORAGE_KEY = 'dashboardUrl';
export const LANGUAGE_STORAGE_KEY = 'languageDashboard';

export const isCompanyAttributeEnabled = (key: string, attr: keyof CompanyAttributesBase): Observable<boolean> => {
  const companyService = inject(CompanyService);
  const storageService = inject(BrowserStorageService);
  return companyService.currentCompany.pipe(
    map(company => {
      const isAllowed = company?.attributes?.[attr] || false;
      storageService.set(key, JSON.stringify(isAllowed));
      return isAllowed;
    })
  );
};

export const dashboardStorageGuard: CanMatchFn = (route): boolean | UrlTree => {
  const storageService = inject(BrowserStorageService);
  const router = inject(Router);
  const storageKey = route.data?.['storageKey'];
  if (!storageKey) {
    return true;
  }
  const redirectUrl = route.data?.['redirectUrl'] || '/home';
  const value = toBoolean(storageService.get(storageKey));
  if (value) {
    return true;
  }
  return router.parseUrl(redirectUrl);
};
